import { lazy, Suspense, useEffect, useState } from "react";
import Header from "./components/Header";
import Home from "./components/Home";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import RequireAdmin from "./components/RequireAdmin";
import RequireOwner from "./components/RequireOwner";
import RequireDeveloper from "./components/RequireDeveloper";
import { Routes, Route, useLocation } from "react-router-dom";
import { doc, setDoc, increment, addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";
import "./index.css";

const About = lazy(() => import("./components/About"));
const Contact = lazy(() => import("./components/Contact"));
const ChaletDetails = lazy(() => import("./components/ChaletDetails"));
const Admin = lazy(() => import("./components/Admin"));
const AdminChalets = lazy(() => import("./components/AdminChalets"));
const AdminEvents = lazy(() => import("./components/AdminEvents"));
const AdminOwners = lazy(() => import("./components/AdminOwners"));
const AdminKnowledgeBase = lazy(() => import("./components/AdminKnowledgeBase"));
const OwnerHome = lazy(() => import("./components/OwnerHome"));
const OwnerCalendar = lazy(() => import("./components/OwnerCalendar"));
const EventDetails = lazy(() => import("./components/EventDetails"));

function App() {
  const { pathname } = useLocation();
  const isAdminPage = pathname.startsWith("/admin") || pathname.startsWith("/owner");
  const [chalets, setChalets] = useState([]);

  useEffect(() => {
    const logVisit = () => {
      const ref = doc(db, "siteStats", "visits");
      setDoc(ref, { count: increment(1) }, { merge: true }).catch(() => {});
      addDoc(collection(db, "visits"), { createdAt: serverTimestamp() }).catch(() => {});
    };

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const id = window.requestIdleCallback(logVisit, { timeout: 4000 });
      return () => window.cancelIdleCallback(id);
    }

    const timer = setTimeout(logVisit, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {!isAdminPage && <Header />}
      <Suspense fallback={<div className="page-loading">جاري التحميل...</div>}>
        <Routes>
          <Route path="/" element={<Home chalets={chalets} setChalets={setChalets} />} />
          <Route path="/chalets/:id" element={<ChaletDetails chaletsList={chalets} />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/chalets" element={<RequireAdmin><AdminChalets /></RequireAdmin>} />
          <Route path="/admin/events" element={<RequireAdmin><AdminEvents /></RequireAdmin>} />
          <Route path="/admin/owners" element={<RequireAdmin><AdminOwners /></RequireAdmin>} />
          <Route path="/admin/knowledge" element={<RequireDeveloper><AdminKnowledgeBase /></RequireDeveloper>} />
          <Route path="/owner" element={<RequireOwner><OwnerHome /></RequireOwner>} />
          <Route path="/owner/chalets/:id" element={<RequireOwner><OwnerCalendar /></RequireOwner>} />
          <Route path="/event/:id" element={<EventDetails />} />
        </Routes>
      </Suspense>
      {!isAdminPage && <Footer />}
      {!isAdminPage && <WhatsAppFloat />}
    </>
  );
}

export default App;
